const MASTER_BRAND = 'MASTER'
const OWNED_BRAND = 'OWNED'

const cleanValue = (value) => `${value ?? ''}`.trim()

const mapSteward = (steward = {}) => ({
  display_name: cleanValue(steward.display_name || steward.name),
  login_id: cleanValue(steward.login_id || steward.enterprise_user_id),
  mail: cleanValue(steward.mail || steward.email),
})

const getBrands = (response) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.brands)) return response.brands
  return []
}

export const formatStatus = (status) =>
  cleanValue(status)
    .toLowerCase()
    .split('_')
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join(' ')

export const formatUpdatedAt = (updatedAt) => {
  if (!updatedAt) return '—'

  const date = new Date(updatedAt)
  if (Number.isNaN(date.getTime())) return '—'

  return new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
    year: 'numeric',
  }).format(date)
}

const mapBrandToCard = (brand, statusLabels) => {
  const lifecycleStatus = cleanValue(brand.brand_lifecycle_status)

  return {
    assetHubProjectUuid: cleanValue(
      brand.assethub_project_uuid || brand.asset_hub_project_uuid,
    ),
    brandId: cleanValue(brand.brand_id),
    brandType: cleanValue(brand.brand_type),
    categoryId: cleanValue(brand.category_id),
    id: cleanValue(brand.id),
    lastUpdated: formatUpdatedAt(brand.updated_at),
    lifecycleStatus,
    name: cleanValue(brand.name),
    primarySteward: mapSteward(brand.primary_steward),
    primaryStewardName:
      cleanValue(brand.primary_steward?.display_name) || 'Unassigned',
    readByAi: brand.brand_ingestion_status === 'SUCCESS',
    slug: cleanValue(brand.slug),
    supportingStewards: (brand.supporting_stewards || []).map(mapSteward),
    statusLabel: statusLabels[lifecycleStatus] || formatStatus(lifecycleStatus),
  }
}

export const mapBrandListToCatalog = (
  response,
  categories = [],
  { statusLabels = {} } = {},
) => {
  const categoriesById = new Map(
    categories.map((category) => [category.id, category]),
  )
  const masterBrands = []
  const ownedGroupsByCategory = new Map()

  getBrands(response).forEach((apiBrand) => {
    const brand = mapBrandToCard(apiBrand, statusLabels)

    if (brand.brandType === MASTER_BRAND) {
      masterBrands.push(brand)
      return
    }

    if (brand.brandType !== OWNED_BRAND) return

    const category = categoriesById.get(brand.categoryId)
    const categoryId = brand.categoryId || 'uncategorized'
    const categoryName = category?.label || category?.name || 'Uncategorized'
    const group = ownedGroupsByCategory.get(categoryId) || {
      brands: [],
      id: categoryId,
      name: categoryName,
    }

    group.brands.push(brand)
    ownedGroupsByCategory.set(categoryId, group)
  })

  return {
    masterBrand: masterBrands[0] || null,
    masterBrands,
    ownedBrandGroups: Array.from(ownedGroupsByCategory.values()),
  }
}
